export default function arrayBufferParse<T>(data: unknown) {
  try {
    const dataView = new DataView(data as ArrayBufferLike);
    const decoder = new TextDecoder('utf8');
    const response = JSON.parse(decoder.decode(dataView)) as T;

    return response;
  } catch {
    return null;
  }
}
